<script lang="ts" setup>
/**
 * @author Ia Gugunava
 */
import type { SecondaryDataInterface } from "@/types/ContentType";
import SlideUpDown from "vue3-slide-up-down";
import Arrow from "~/components/regularComponents/UIComponents/SVG/Arrow.vue";

defineProps<{
  contentData?: SecondaryDataInterface;
}>();

const isActive = ref<Array<boolean>>([]);

const onQuestionClick = (index: number) => {
  isActive.value.forEach((_, i) => {
    if (i !== index) {
      isActive.value[i] = false;
    }
  });
  isActive.value[index] = !isActive.value[index];
};
</script>

<template>
  <div class="faq pos-rel">
    <div class="container">
      <div class="faq__header">
        <h2 class="faq__title headline-4 c-black uppercase hl-2">
          {{ contentData?.conf?.header?.title }}
        </h2>
      </div>

      <div class="faq__content">
        <div
          class="faq__questions"
          v-for="(item, index) in contentData?.data?.list"
          :key="index"
        >
          <div
            class="faq__questions-question pointer d-flex al-center j-btw c-black"
            :class="{ active: isActive[index] }"
            @click="onQuestionClick(index)"
          >
            <h2 class="headline-5">{{ item?.title }}</h2>

            <div class="faq__questions-arrow">
              <Arrow />
            </div>
          </div>

          <SlideUpDown v-model="isActive[index]">
            <div
              class="faq__questions-answer p-18 text-normal"
              v-html="item?.teaser"
            ></div>
          </SlideUpDown>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.faq {
  z-index: 1;
  margin-top: 140px;

  @include maxq(desktop) {
    margin-top: 178px;
  }

  @include maxq(tablet) {
    margin-top: 92px;
    overflow: hidden;
  }

  @include maxq(mobile) {
    margin-top: unset;
    height: fit-content;
  }
  &__header {
    padding-left: 48px;
    margin-bottom: 64px;

    @include maxq(desktop) {
      padding-left: 28px;
    }
    @include maxq(tablet) {
      padding-left: 0;
    }
  }
  //   &__title {
  //     font-size: 84px;
  //     line-height: 102px;
  //     @include maxq(desktop-sm) {
  //       font-size: 68px;
  //       line-height: 82.89px;
  //     }
  //     @include maxq(mobile) {
  //       margin-bottom: 16px;
  //       line-height: 82px;
  //     }
  //   }
  &__content {
    border-top: 1px solid $brightGray;
  }
  &__questions {
    &-question {
      padding: 24px 0;
      border-bottom: 1px solid $brightGray;
      padding-left: 24px;
      @include easeInOut(500ms, all);
      h2,
      svg,
      path {
        @include easeInOut(500ms, all);
        fill: #1f1f1f;
      }
      &.active {
        background-color: #f8f8f8;
        svg {
          transform: rotate(180deg);
        }
      }
    }

    &-arrow {
      width: 24px;
      height: 24px;
      margin-left: 10px;
      margin-right: 24px;
      flex-shrink: 0;

      svg {
        width: 100%;
        height: 100%;
      }
    }

    &-answer {
      padding: 24px;
      color: #1f1f1f;
      background-color: #f8f8f8;
    }
  }
}
</style>
